module.exports = __webpack_public_path__ + "img/ws.3c449121.svg";